<template>
 <div class="container" v-if="isAdmin">
   <h1>Users</h1>
   <div class="user-header">
      <div class="user-id">
        ID
      </div>
      <div class="user-pic"></div>
      <div class="user-name">
        USER NAME
      </div>
      <div class="user-display-name">
        DISPLAY NAME
      </div>
      <div class="user-email">
        EMAIL ADDRESS
      </div>
      <div class="user-connection">
        CONNECTION
      </div>
   </div>
   <div v-for="user in allUsers" :key="user.id" class="user-items">
      <div class="user-id">
        {{user._id}}
      </div>
      <div class="user-pic">
        <img :src="user.profilePic" />
      </div>
      <div class="user-name">
        <router-link :to="`/user/${user.userName}`">
          {{user.userName}}
        </router-link>
      </div>
      <div class="user-display-name">
        {{user.displayName}}
      </div>
      <div class="user-email">
        {{user.email}}
      </div>
      <div class="user-connection">
        {{user.connection}}
      </div>
   </div>
 </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'admin-users',
  data() {
    return {
      allUsers: [],
      isAdmin: false,
    };
  },
  async mounted() {
    try {
      const adminUsersResponse = await this.backendAxios.get('/admin/users');
      this.allUsers = adminUsersResponse.data;
      this.isAdmin = true;
    } catch (err) {
      this.$toasted.show(err.response.data, {
        type: 'info',
        duration: 5000,
      });
      this.$router.push('/');
    }
  },
  computed: {
    ...mapState('auth', ['backendAxios']),
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: left;
}

.user-items, .user-header {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  text-align: left;
  padding-bottom: 1rem;
  & * {
    overflow: auto;
  }
}

.user-header {
  font-weight: bold;
}

.user-pic {
  width: 10%;
  text-align: right;
}

.user-pic img {
  object-fit: fill;
  width: 100%;
  max-width: 2rem;
}

.user-id {
  width: 15%;
}

.user-name {
  width: 10%;
}

.user-display-name {
  width: 20%;
}

.user-email {
  width: 20%;
}

.user-connection {
  width: 10%;
}

</style>
